var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "netgsm-cdr" } },
    [
      _c("div", { staticClass: "page-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "a-button",
              {
                attrs: { loading: _vm.loading, icon: "reload" },
                on: { click: _vm.refreshData },
              },
              [_vm._v(" Yenile ")]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: {
                  type: "primary",
                  loading: _vm.loading,
                  icon: "download",
                },
                on: { click: _vm.exportCDR },
              },
              [_vm._v("\n                Dışa Aktar\n            ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar" }, [
        _c(
          "div",
          { staticClass: "toolbar-filter" },
          [
            _c("a-input-search", {
              staticClass: "search-input",
              staticStyle: { width: "300px" },
              attrs: {
                placeholder: "CDR ID, Numara veya Unique ID ile ara...",
                loading: _vm.loading,
              },
              on: { search: _vm.onSearch },
              model: {
                value: _vm.searchText,
                callback: function ($$v) {
                  _vm.searchText = $$v
                },
                expression: "searchText",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "date-filter-inline" },
              [
                _c("span", { staticClass: "date-label" }, [
                  _vm._v("Tarih (Max 1 gün):"),
                ]),
                _vm._v(" "),
                _c("a-date-picker", {
                  staticStyle: { width: "200px" },
                  attrs: { format: "DD.MM.YYYY", placeholder: "Tarih seçin" },
                  on: { change: _vm.onDateChange },
                  model: {
                    value: _vm.selectedDate,
                    callback: function ($$v) {
                      _vm.selectedDate = $$v
                    },
                    expression: "selectedDate",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "date-required" }, [_vm._v("*")]),
                _vm._v(" "),
                _c("small", { staticClass: "date-help" }, [
                  _vm._v("NetGSM API'si maksimum 1 günlük aralığı destekler"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "toolbar-actions" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "statistics" }, [
        _c("div", { staticClass: "stats-grid" }, [
          _c("div", { staticClass: "stat-card total-calls" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.statistics.totalCalls)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [
                _vm._v("Toplam Arama"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-card answered-calls" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.statistics.answeredCalls)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [_vm._v("Cevaplanmış")]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-percentage" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      _vm.statistics.totalCalls > 0
                        ? Math.round(
                            (_vm.statistics.answeredCalls /
                              _vm.statistics.totalCalls) *
                              100
                          )
                        : 0
                    ) +
                    "%\n                    "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-card total-duration" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.statistics.totalDuration)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [_vm._v("Toplam Süre")]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-unit" }, [_vm._v("dakika")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-card average-duration" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.statistics.averageDuration)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [
                _vm._v("Ortalama Süre"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-unit" }, [_vm._v("dakika")]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("SupsisTable", {
            attrs: {
              columns: _vm.getCols(),
              rows: _vm.cdrRecords,
              loading: _vm.loading,
              "top-pagination": "",
              "bottom-pagination": "",
              "pagination-cursor": _vm.pagination,
              options: {
                fixedHeader: true,
                borderX: true,
                borderY: true,
              },
              "pagination-options": [
                10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000,
              ],
            },
            on: { "cursor-changed": _vm.onPaginationChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Arama Detayları", footer: null, width: "700px" },
          model: {
            value: _vm.showDetailModal,
            callback: function ($$v) {
              _vm.showDetailModal = $$v
            },
            expression: "showDetailModal",
          },
        },
        [
          _vm.selectedCall
            ? _c(
                "div",
                [
                  _c(
                    "a-descriptions",
                    { attrs: { column: 2, bordered: "", size: "small" } },
                    [
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "CDR ID" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selectedCall.cdrid) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("a-descriptions-item", { attrs: { label: "Tarih" } }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm
                                .$moment(_vm.selectedCall.calldate)
                                .format("DD.MM.YYYY HH:mm:ss")
                            ) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Arayan (CLI)" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selectedCall.cli) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Aranan (CLD)" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selectedCall.cld) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Yön" } },
                        [
                          _c(
                            "a-tag",
                            {
                              attrs: {
                                color: _vm.getDirectionColor(
                                  _vm.selectedCall.direction
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.getDirectionText(
                                      _vm.selectedCall.direction
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Durum" } },
                        [
                          _c(
                            "a-tag",
                            {
                              attrs: {
                                color: _vm.getStatusColor(
                                  _vm.selectedCall.status
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.selectedCall.status) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Toplam Süre" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.formatDuration(_vm.selectedCall.duration)
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Konuşma Süresi" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.formatDuration(_vm.selectedCall.billsec)
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Unique ID", span: "2" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selectedCall.uniqueid) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.selectedCall.recordurl
                        ? _c(
                            "a-descriptions-item",
                            { attrs: { label: "Kayıt Dosyası", span: "2" } },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "recording-link",
                                  attrs: {
                                    href: _vm.selectedCall.recordurl,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("play_circle"),
                                  ]),
                                  _vm._v(
                                    "\n                        Kayıt İndir\n                    "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("h3", [_vm._v("Arama Kayıtları (CDR)")]),
      _vm._v(" "),
      _c("p", [_vm._v("NetGSM arama detay kayıtlarını görüntüleyin")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("call")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("call_received")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("schedule")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("timer")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }